import { render, staticRenderFns } from "./BP_editor_copy.vue?vue&type=template&id=2e9aff67"
import script from "./BP_editor_copy.vue?vue&type=script&lang=js"
export * from "./BP_editor_copy.vue?vue&type=script&lang=js"
import style0 from "./BP_editor_copy.vue?vue&type=style&index=0&id=2e9aff67&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports